import React from "react";

const InfoCard = () => {
  const ContactCard = ({ icon, title, details }) => (
    <div className="flex-1 p-4 m-2 bg-white rounded-lg shadow-md text-center">
      <div className="flex justify-center mb-2">{icon}</div>
      <h3 className="text-lg font-semibold text-gray-700">{title}</h3>
      <p className="text-gray-600">{details}</p>
    </div>
  );
  return (
    <div className="font-serif">
      <div className="">
        <h1 className="text-2xl md:text-3xl font-bold text-blue-900 mb-4 text-center">
          We are here to help you
        </h1>
        <p className="text-gray-600 mb-6 text-center">
          Various versions have evolved over the years sometimes by accident
          sometimes on purpose injected humour and the like.
        </p>
        <div className="flex flex-col md:flex-row justify-around">
          <ContactCard
            icon={<span className="text-4xl text-green-500">📦</span>}
            title="BRANCH OFFICE"
            details="Tembo House Building, Moi Avenue, 6th Floor - Office No. 1"
          />
          <ContactCard
            icon={<span className="text-4xl text-green-500">📧</span>}
            title="EMAIL ADDRESS"
            details="info@bundainvestment.com"
          />
          <ContactCard
            icon={<span className="text-4xl text-green-500">📞</span>}
            title="CALL US AT"
            details="0740000077/0108555888"
          />
        </div>
      </div>
    </div>
  );
};

export default InfoCard;
